"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THEME = exports.SIZE_TO_PADDING = exports.SIZE_TO_HEIGHT = exports.INNER_CONTAINER_PADDING_X = exports.CONTAINER_PADDING_Y = exports.CONTAINER_PADDING_X = void 0;
var _colors = _interopRequireDefault(require("../../styles/colors"));
var CONTAINER_PADDING_X = exports.CONTAINER_PADDING_X = 6;
var CONTAINER_PADDING_Y = exports.CONTAINER_PADDING_Y = 1;
var INNER_CONTAINER_PADDING_X = exports.INNER_CONTAINER_PADDING_X = 12;
var SIZE_TO_HEIGHT = exports.SIZE_TO_HEIGHT = {
  sm: {
    defaultSize: 38,
    enlargedSize: 54
  },
  md: {
    defaultSize: 42,
    enlargedSize: 64
  }
};
var SIZE_TO_PADDING = exports.SIZE_TO_PADDING = {
  sm: 4,
  md: 6
};
var THEME = exports.THEME = {
  neutral: {
    color: 'textPrimary',
    accentColor: _colors["default"].accent100,
    hoverColor: _colors["default"].neutral100,
    textTypes: {
      sm: 'body14',
      md: 'body16'
    }
  },
  accent: {
    color: 'accent500',
    accentColor: _colors["default"].accent100,
    hoverColor: _colors["default"].accent100,
    textTypes: {
      sm: 'emphasis14',
      md: 'emphasis16'
    }
  },
  danger: {
    color: 'danger500',
    accentColor: _colors["default"].danger100,
    hoverColor: _colors["default"].danger100,
    textTypes: {
      sm: 'body14',
      md: 'body16'
    }
  },
  disabled: {
    color: 'textDisabled',
    accentColor: _colors["default"].white,
    hoverColor: _colors["default"].white,
    textTypes: {
      sm: 'body14',
      md: 'body16'
    }
  }
};
//# sourceMappingURL=HBListItem.constants.js.map